import { get } from '@/utils/apiBase.js'

const getItemAuditReason = option => {
    return get('/apis/project/cp/get_item_audit_reason', option)
}

export default {
    getItemAuditReason
}
